/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAuth } from '../../../context/auth/AuthContext'
import './OrderHistoryPage.css'
import { IOrderInProgress } from "../../../models/order/aggregates/progress/IOrderInProgress";
import { IHistorySectionOrder } from '../../../models/order/aggregates/history/IOrderHistory'
import { OrderHistoryApi } from '../../../services/Api/order/OrderHistoryApi';
import { OrdersInProgressList } from './ordersInProgressList/OrdersInProgressList';
import { useUi } from '../../../context/ui/UIContext';
import OldOrderList from './oldOrdersList/OldOrderList';
import { useI18n } from 'utils/i18n/hooks/useI18n';

export const OrderHistory = () => {

    const orderHistoryApi = OrderHistoryApi();
    const [orderInProgress, setOrderInProgress] = useState<IOrderInProgress[]>()
    const [sectionOrders, setSectionOrders] = useState<IHistorySectionOrder[]>([])
    const { user } = useAuth()
    const { showLoading, hideLoading } = useUi()
    const { t } = useI18n();
    const isMounted = useRef(true);

    const getInProgressOrders = useCallback(
        async () => {
            try {
                showLoading()
                const response = await orderHistoryApi.getInProgressOrders();
                if (response && isMounted.current) { 
                    setOrderInProgress(response.data);
                }
            } finally {
                hideLoading()
            }
        },
        [],
    )

    const getOrderHistory = useCallback(
        async (userId: string) => {
            const response = await orderHistoryApi.getByUser(userId);
            if (response && isMounted.current) {  
                setSectionOrders(response.data);
            }
        },
        [],
    )

    useEffect(() => {
        isMounted.current = true;
        getOrderHistory(user.id);
        getInProgressOrders();
        return () => {
            isMounted.current = false;  
        };
    }, [user])

    return (
        <div id="orderHistoryPage">
            <div className="title-orderHistoryPage">{t("orders.titles.inProgress")}</div>
            { orderInProgress && <OrdersInProgressList ordersInProgressList={orderInProgress} ></OrdersInProgressList> }
            <div className="title-orderHistoryPage">{t("orders.titles.completed")}</div>
            {sectionOrders.map((orderHistory, index) => (
                <OldOrderList key={`section-${index}-${orderHistory.date}`} orders={orderHistory} />
            ))}
        </div>
    )
}
